import { StringKeys } from '../../resources/strings/StringKeys';

export const validatePassword = (password, t) => {
  const errors = [];
  
  // Check minimum length
  if (password.length < 8) {
    errors.push(t(StringKeys.PASSWORD_MUST_BE_AT_LEAST_8_CHARACTERS));
  }

  // Check maximum length
  if (password.length > 4096) {
    errors.push(t(StringKeys.PASSWORD_CANNOT_EXCEED_4096_CHARACTERS));
  }

  // Check for uppercase
  if (!/[A-Z]/.test(password)) {
    errors.push(t(StringKeys.PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_UPPERCASE_LETTER));
  }

  // Check for lowercase
  if (!/[a-z]/.test(password)) {
    errors.push(t(StringKeys.PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_LOWERCASE_LETTER));
  }

  // Check for numeric character
  if (!/[0-9]/.test(password)) {
    errors.push(t(StringKeys.PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_NUMBER));
  }

  // Check for special character
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push(t(StringKeys.PASSWORD_MUST_CONTAIN_AT_LEAST_ONE_SPECIAL_CHARACTER));
  }

  return {
    isValid: errors.length === 0,
    errors
  };
}; 